import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/cA-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "motto" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Code Awareness")
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createTextVNode("Re:imagine"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Working"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Together")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_CAHeader = _resolveComponent("CAHeader")!
  const _component_CAFooter = _resolveComponent("CAFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createElementVNode("div", {
      class: "container",
      style: _normalizeStyle({ backgroundImage: 'url(' + $setup.bgImage + ')' })
    }, [
      _createVNode(_component_CAHeader),
      _hoisted_1,
      _createElementVNode("main", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_component_CAFooter)
    ], 4)
  ], 64))
}